module.exports = __webpack_public_path__ + "img/86.a3b54193.jpg";